/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/

import cdn from './items/cdn'
import encoder from './items/encoder'
import storage from './items/storage'
import security from './items/security'
import observability from './items/observability'
// import databases from './items/databases'
// import compute from './items/compute'
// import kyubi from './items/kyubi'

export default [
  ...cdn,
  ...encoder,
  ...storage,
  ...observability,
  ...security,
  // {
  //   header: 'in Beta Services',
  // },
  // ...compute,
  // ...databases,
  // ...kyubi,
  ...(process.env.NODE_ENV === 'development'
    ? [
      {
        title: 'Gjirafa Icons',
        gjIcon: 'Image',
        route: 'gj-icons',
      },
    ]
    : []),
]
